import React from "react";
import "./Footer.css";
import Logo from "../assets/fleur-logo-white-2-no-background.png";
import { FaFacebook, FaInstagram } from "react-icons/fa"; // social icons

const Footer = () => {
  return (
    <footer className="footer">
      {/* === MAIN CONTAINER === */}
      <div className="footer-content">

        {/* ---------- LEFT SECTION: BRAND ---------- */}
        <div className="footer-section">
          <img
            src={Logo}
            alt="Fleur Designs Photography Logo"
            className="footer-logo-img"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          />
          <h2 className="footer-logo">Fleur Designs Photography</h2>
          <p className="footer-text">
            “Turning your simple moments into precious memories”
          </p>
        </div>

        {/* ---------- MIDDLE SECTION: QUICK LINKS ---------- */}
        <div className="footer-section">
          <h3 className="footer-title">Quick Links</h3>
          <ul className="footer-links">
            <li><a href="#hero">Home</a></li>
            <li><a href="#about">About Mbali</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#testimonials">Testimonials</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        {/* ---------- RIGHT SECTION: SOCIAL & CONTACT ---------- */}
        <div className="footer-section">
          <h3 className="footer-title">Follow Us</h3>

          {/* Social icons */}
          <div className="footer-socials">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook />
            </a>

            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </div>

          {/* Contact info */}
          <p
            className="footer-contact"
            href="tel:+27828179265"
            target="_blank"
            rel="noopener noreferrer"
          >
            <a href="tel:+27828179265">📞 082 817 9265</a>
          </p>
          
          <p
            className="footer-contact"
          >
            <a href="mailto:mbalimapaila@icloud.com<">📧 mbalimapaila@icloud.com</a>
          </p>
        </div>
      </div>

      {/* ---------- COPYRIGHT BAR ---------- */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Fleur Designs Photography — All Rights Reserved.
      </div>

    </footer>
  );
};

export default Footer;
